import React from "react";
import AuthLayout from "../authlayout/authlayout";
import styles from "./signupstudent.module.scss";
import { ERCText } from "components/text";
import ERCInput from "components/Input";
import { MdOutlineErrorOutline } from "react-icons/md";
import { ERCForm } from "components/form";
import { setUser } from "store/reducers/user";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { ERCButton } from "components/button";
import dropDown from "./drodown";
import Input from "components/dashboard/forms/Input";

const SignupStudent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const location = useLocation();
  const { Sector } = dropDown;
  const schema = Yup.object().shape({
    email: Yup.string().required(),
    password: Yup.string()
      .required("Password is Required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
    confirm: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is Required")
      .matches(
        /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
        "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      ),
    fullName: Yup.string().required(),
    sector: Yup.string().required(),
  });

  const handleSuccess = (res) => {
    dispatch(setUser(res));
    navigate(-1);
  };

  return (
    <AuthLayout>
      <div className={styles.body}>
        <div className={styles.signup}>
          <div className={styles.signin}>
            <ERCButton
              bgcolor="#F6F5B2"
              color="#00296B"
              width="100px"
              onClick={() => navigate(-1)}
            >
              {" "}
              Sign In
            </ERCButton>
          </div>
          <div className={styles.logo}>
            <img
              src={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1716814039/ERC/erc_main_logo_nbljik.svg"
              }
              alt="logo"
            />
          </div>

          <div className={styles.create}>
            <ERCText weight="700" size="30px">
              Create An Account
            </ERCText>
            <div className={styles.several}>
              <span style={{ color: "#FFD600" }}>
                <MdOutlineErrorOutline size={20} />{" "}
              </span>
              <ERCText size="12px">
                Access several courses today as a{" "}
                <span style={{ color: "#FFD600", fontWeight: "600" }}>
                  Student.
                </span>{" "}
                Kindly fill out the form.
              </ERCText>
            </div>
          </div>
          <ERCForm
            extraFields={{ userType: "student" }}
            validationSchema={schema}
            inputsContainer={"flex flex-col gap-[24px]"}
            className={
              "!w-[430px] justify-center items-center flex flex-col gap-[56px] "
            }
            btnClass={"!w-[100%] !bg-[#FFD600] !text-[16px] !text-[#00296B]"}
            btnText={"Create Account"}
            method={"post"}
            url={"/user/register"}
            noToken
            // onSuccess={(res) => {
            //     dispatch(setUser(res))
            //     navigate('/students-dashboard')
            // }}
            onSuccess={handleSuccess}
            onError={(err) => {
              if (err?.response) {
                // toast.error(err)
                console.log(err);
                toast.error("User already exists");
              }
            }}
          >
            <div className="w-full flex gap-6">
              <div className="md:w-1/2 w-full">
                <ERCInput
                  containerClass="w-[auto]"
                  label="Full Name"
                  name="fullName"
                  placeholder="Enter your full name"
                />
              </div>
              <div className="md:w-1/2 w-full">
                <ERCInput
                  containerClass="w-[auto]"
                  label="Email Address"
                  name="email"
                  placeholder="Enter your email address"
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "20px", width: "100%" }}>
              <div className="md:w-1/2 w-full">
                <ERCInput
                  containerClass="w-[auto]"
                  label="Phone Number"
                  placeholder="Enter your phone number"
                />
              </div>
              {/* <div >
                                <ERCInput type='select' containerClass='!w-[255px]' label='Sector' placeholder='Choose your sector' />
                            </div> */}
              <div className="md:w-1/2 w-full">
                <ERCInput
                  type="select"
                  name="sector"
                  containerClass="!w-[255px]"
                  label="Sector"
                  placeholder="Select your sector"
                  options={Sector}
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "20px" }}>
              <div className="">
                <ERCInput
                  containerClass="w-[auto]"
                  type="password"
                  label="Password"
                  name="password"
                  placeholder="Enter Password"
                />
              </div>
              <div>
                <ERCInput
                  containerClass="w-[auto]"
                  type="password"
                  label="Confirm Password"
                  name="confirm"
                  placeholder="Confirm Password"
                />
              </div>
            </div>
          </ERCForm>

          <div>
            <ERCText size="15px">
              By creating an Account you agree to the{" "}
              <span style={{ color: "#FFD600" }}>Terms & Conditions</span> and{" "}
              <span style={{ color: "#FFD600" }}>Privacy Policy </span>
            </ERCText>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default SignupStudent;
